/* eslint-disable no-restricted-syntax */
import { IStatusFieldOption } from 'store/field-options/types';
import { IStoreState } from 'store';

// Gets the currently active statuses to populate the legend status list
export const getStatusesForLegend = (state: IStoreState): IStatusFieldOption[] => {
  const statusesForLegend: IStatusFieldOption[] = [];

  const { pareto, fieldOptions } = state;
  const { statuses } = fieldOptions;
  const { portfolioDeals } = pareto;

  if (!statuses || !portfolioDeals) {
    return statusesForLegend;
  }

  portfolioDeals.forEach(deal => {
    for (const statuse of statuses) {
      if (statuse.name === deal.status) {
        const existingStatuses = statusesForLegend.map(statusForLegend => statusForLegend.name);
        const indexOf = existingStatuses.indexOf(deal.status);
        if (indexOf === -1) {
          statusesForLegend.push(statuse);
        }
        break;
      }
    }
  });

  return statusesForLegend;
};
